import React from 'react';

export const Context = React.createContext();
export const { Provider, Consumer } = Context;
